import { useTranslation } from 'react-i18next';

export function LiveScreen() {
  const { t } = useTranslation();
  return <div className="screen screen--live">{t('nav.live')}</div>;
}
